import { Link } from 'react-router-dom';
import { copy } from '@/content/copy';
import { useCartCount } from '@/features/cart/useCartCount';
import { cn } from '@/lib/utils';

/**
 * `floating` sits the bar over the hero on the landing page. Everywhere else it
 * is a solid sticky bar, so the shop and policy pages start with readable
 * content instead of text over an image.
 */
export function StoreHeader({
  onOpenCart,
  floating = false,
}: {
  onOpenCart: () => void;
  floating?: boolean;
}) {
  const count = useCartCount();

  return (
    <header
      className={cn(
        'z-30 grid min-h-[78px] grid-cols-[1fr_auto] items-center gap-[18px]',
        'px-[clamp(24px,3vw,44px)] py-4',
        'max-[560px]:min-h-0 max-[560px]:px-[18px] max-[560px]:py-3.5',
        floating
          ? 'absolute inset-x-0 top-0 bg-[linear-gradient(180deg,rgba(0,0,0,0.52),transparent)] max-[560px]:relative max-[560px]:bg-night'
          : 'sticky top-0 border-b border-brand-line bg-night/95 backdrop-blur',
      )}
    >
      <Link
        to="/"
        aria-label={copy.brand.homeLabel}
        className="sig text-[clamp(2.1rem,3vw,3rem)] leading-none text-cream transition-opacity hover:opacity-80"
      >
        {copy.brand.name}
      </Link>

      <button
        type="button"
        onClick={onOpenCart}
        aria-label={`${copy.header.cart} ${count} — ${copy.header.openCart}`}
        className="flex items-center gap-2.5 whitespace-nowrap border-l border-brand-line py-2.5 pl-4 font-serif text-[1.1rem] text-cream transition-colors hover:text-gold-soft max-[560px]:py-1.5 max-[560px]:pl-3"
      >
        {copy.header.cart}{' '}
        <span className="inline-grid h-[22px] min-w-[22px] place-items-center rounded-[11px] bg-gold px-1.5 text-[0.75rem] font-semibold text-night">
          {count}
        </span>
      </button>
    </header>
  );
}
